export default "__VITE_ASSET__B65ZW88q__"